<template>
  <div class="fast-feedback">
    <div
      v-for="item in items"
      :key="item.id"
      :class="['fast-feedback-item', { select: item.select }]"
      @click="$emit('select', item.id)"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'FastFeedback',

  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="less">
.fast-feedback {
  display: flex;
  flex-wrap: wrap;

  &-item {
    margin-bottom: 10px;
    padding: 9px 15px;
    border-radius: 18px;
    font-size: 16px;
    line-height: 1;
    color: #9d9d9d;
    text-align: center;
    background-color: #ffffff;

    &:not(:last-of-type) {
      margin-right: 10px;
    }

    &.select {
      color: #ffffff;
      background-color: #ff8376;
    }
  }
}
</style>
